import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [stage, setStage] = useState("request"); // request | reset
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const request = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("If an account exists, a reset email has been sent. Check your inbox (or Email Log)");
      setStage("reset");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not start reset");
    } finally {
      setBusy(false);
    }
  };

  const reset = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. You can now log in.");
      window.location.href = "/login";
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm border border-border bg-card rounded-2xl p-8" data-testid="forgot-password-form">
        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">← Back</Link>
        <h1 className="mt-3 font-display text-2xl font-bold">Reset your password</h1>
        {stage === "request" ? (
          <form onSubmit={request} className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-medium">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-md border border-input px-3 py-2 text-sm bg-transparent focus:ring-2 focus:ring-ring focus:outline-none" data-testid="forgot-email" />
            </div>
            <button disabled={busy} className="w-full rounded-md bg-primary text-primary-foreground py-2.5 font-medium hover:bg-primary/90 disabled:opacity-50" data-testid="forgot-submit">
              {busy ? "Sending…" : "Send reset email"}
            </button>
          </form>
        ) : (
          <form onSubmit={reset} className="mt-6 space-y-4">
            <p className="text-sm text-muted-foreground">Check your email (or the Email Log once logged in) for the reset token.</p>
            <div>
              <label className="text-sm font-medium">Reset token</label>
              <input required value={token} onChange={(e) => setToken(e.target.value)} className="mt-1 w-full rounded-md border border-input px-3 py-2 text-sm bg-transparent focus:ring-2 focus:ring-ring focus:outline-none" data-testid="reset-token" />
            </div>
            <div>
              <label className="text-sm font-medium">New password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full rounded-md border border-input px-3 py-2 text-sm bg-transparent focus:ring-2 focus:ring-ring focus:outline-none" minLength={6} data-testid="reset-password" />
            </div>
            <button disabled={busy} className="w-full rounded-md bg-primary text-primary-foreground py-2.5 font-medium hover:bg-primary/90 disabled:opacity-50" data-testid="reset-submit">
              {busy ? "Resetting…" : "Reset password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
